module.exports = __webpack_public_path__ + "static/eventHeader-e8da9ce10ae4fe0f601d296679a044fd.jpeg";